import React, { useContext } from "react";
import { useState } from "react";
import { useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useLocation, useNavigate } from "react-router";
import PageHeader from "../pageheader/PageHeader";
import MenuAdmin from "./navAdmin/Menu";
import * as adminApi from "../../service/adminApi";
import TextEditer from "../material/textEditor/TextEditor";
import TinyMCE from "../material/tinymce/TinyMCE";
import Select from "../material/select/Select";
import Draft from "../material/texteditorDraft/Draft";
import Datepicker from "../material/datepicker/Datepicker";
import ToggleCheckbox from "../material/toggleCheckbox/ToggleCheckbox";
import { RedirectCode400 } from "../RedirectCode400";
import { convertToYMD } from "../utility/Helper";

import { CurrentUserContext } from "../../App";

import Breadcrumb from "../breadcrumb/breadcrumb";

function AddDataUseQuillEditor() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [titlepage, setTitlePage] = useState("");
  const [titleValue, setTitleValue] = useState("");
  const [detailValue, setDetailValue] = useState("");
  const [publishStartDate, setPublishStartDate] = useState("");
  const [publishEndDate, setPublishEndDate] = useState("");
  const [active, setActive] = useState(true);
  const [pined, setPined] = useState(false);
  const [type, setType] = useState("");

  const [defaultOption, setDefaultOption] = useState("");
  const [disableType, setDisableType] = useState(false);

  let typeList = [
    {
      key: "news",
      value: "ข่าวประชาสัมพันธ์",
    },
    {
      key: "article",
      value: "บทความ",
    },
    {
      key: "announcement",
      value: "ประกาศ",
    },
  ];

  useEffect(() => {
    if (location.state?.type === "guideline") {
      setTitlePage(
        location.state?.data ? "แก้ไขแนวทางการตรวจ" : "เพิ่มแนวทางการตรวจ",
      );
      setTitleValue(location.state?.data?.title);
      setDetailValue(location.state?.data?.detail);
      setDefaultOption("1");
    } else if (location.state?.type === "newsPublicSign") {
      //console.log(location.state?.data)
      setTitlePage(
        location.state?.data
          ? "แก้ไขข่าวสารประชาสัมพันธ์"
          : "เพิ่มข่าวสารประชาสัมพันธ์",
      );
      setTitleValue(location.state?.data?.title);
      setDetailValue(location.state?.data?.description);

      if (location.state?.data?.publish_start_date?.date) {
        setPublishStartDate(
          new Date(location.state?.data?.publish_start_date?.date),
        );
      }

      if (location.state?.data?.publish_end_date?.date) {
        setPublishEndDate(
          new Date(location.state?.data?.publish_end_date?.date),
        );
      }

      if (location.state?.data?.active) {
        setActive(location.state?.data?.active);
      } else {
        setActive(false);
      }

      if (location.state?.data?.pined) {
        setPined(location.state?.data?.pined);
      }

      if (location.state?.data?.type) {
        setType(location.state?.data?.type);
      }

      setDefaultOption("3");
    } else {
      navigate("/managewebsite/add-press-release");
      //ถ้าไม่มี type ให้ส่งกลัับไปหน้า manage
    }
  }, []);

  //console.log(detailValue)

  const addGuideline = async () => {
    setLoading(true);
    let res = await adminApi.addGuideline(titleValue, detailValue);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/managewebsite", {
          state: {
            type: "แนวทางการตรวจ",
            option: "1",
          },
        });
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };
  const addAnnouncement = async () => {
    setLoading(true);
    let res = await adminApi.addAnnouncement(titleValue, detailValue);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/managewebsite");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };
  const addContent = async () => {
    setLoading(true);
    let publishStartDateString = convertToYMD(publishStartDate);
    let publishEndDateString = convertToYMD(publishEndDate);
    let res = await adminApi.addContent(
      type,
      titleValue,
      detailValue,
      publishStartDateString,
      publishEndDateString,
      active,
      pined,
    );
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/managewebsite/add-press-release");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const updateContent = async () => {
    setLoading(true);
    let publishStartDateString = convertToYMD(publishStartDate);
    let publishEndDateString = convertToYMD(publishEndDate);
    let res = await adminApi.updateContent(
      location.state?.data?.content_id,
      type,
      titleValue,
      detailValue,
      publishStartDateString,
      publishEndDateString,
      active,
      pined,
    );
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/managewebsite/add-press-release");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const onClickAddSubmit = (type) => {
    // console.log(titleValue, active, pined, publishStartDate);
    if (!titleValue) {
      setIsMessage({ type: "warning", data: "กรุณากรอกหัวข้อ" });
    } else if (!detailValue) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรายละเอียด" });
    } else if (!publishStartDate) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกวันที่เผยแพร่" });
    } else {
      if (type === "guideline") {
        addGuideline();
      } else if (type === "newsPublicSign") {
        //ไว้ยิงapi save ประชาสัมพันธ์
        addContent();
      } else {
        // console.log(type, "log จาก AddDataUseQuillEditor");
      }
    }
  };

  const onClickUpdateSubmit = (type) => {
    if (!titleValue) {
      setIsMessage({ type: "warning", data: "กรุณากรอกหัวข้อ" });
    } else if (!detailValue) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรายละเอียด" });
    } else if (!publishStartDate) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกวันที่เผยแพร่" });
    } else {
      if (type === "news") {
        updateContent();
      }
    }
  };

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "จัดการข้อมูลเว็บไซด์", url: "/managewebsite" },
    { name: "ข่าวสารประชาสัมพันธ์", url: "/managewebsite/add-press-release" },
    {
      name: "เพิ่มข่าวสารประชาสัมพันธ์",
      url: "/managewebsite/add-press-release/add-data-use-quill-editor",
    },
  ];

  return (
    <div className="global-page">
      <MenuAdmin menuActive={"managewebsite"} />
      <Breadcrumb pathItems={pathItems} />
      <PageHeader
        titlename={titlepage}
        backpath={"/managewebsite/add-press-release"}
        type_v2={"แนวทางการตรวจ"}
        option={defaultOption}
        btnBackWard
      />
      <div className="md:m-4 ml-24 mr-24 md:mx-2">
        {/* <div className="md:text-[14px] text-xl text-[#000000] md:my-1 my-3">
          หัวข้อ
        </div>
        <input
          value={titleValue}
          onChange={(e) => {
            setTitleValue(e.target.value);
          }}
          className="border-2 border-solid border-[#A2B5BC] rounded-lg md:text-[14px] text-[#000000] md:p-2 p-5 focus:outline-none md:mt-0 md:mb-0 mt-1 mb-4 w-full"
        ></input>
        <div className="">
          <div className="w-full sm:w-auto mt-4 sm:mt-0">
            <ToggleCheckbox
              label="ปักหมุด"
              value={pined}
              setValue={setPined}
            ></ToggleCheckbox>
          </div>
        </div> */}
        <div>
          <div className="md:text-[14px] text-xl text-[#000000] md:my-1 my-3">
            ประเภทเนื้อหา
          </div>
          <Select
            disabled={disableType}
            value={type}
            setValue={setType}
            list={typeList}
            placeholder="เลือกประเภทเนื้อหา"
          ></Select>
        </div>
        <div>
          <div className="md:text-[14px] text-xl text-[#000000] md:my-1 my-3">
            หัวข้อ
          </div>
          <div className="flex items-center gap-2">
            <input
              value={titleValue}
              onChange={(e) => {
                setTitleValue(e.target.value);
              }}
              type="text"
              className="border-2 border-solid border-[#A2B5BC] rounded-lg md:text-[14px] text-[#000000] md:p-2 p-5 focus:outline-none md:mt-0 md:mb-0 mt-1 mb-4 w-full"
              placeholder=""
            />
            <div className="sm:hidden">
              <ToggleCheckbox
                label="ปักหมุด"
                value={pined}
                setValue={setPined}
              />
            </div>
          </div>
        </div>
        <div className="md:text-[14px] text-xl text-[#000000] md:my-1 my-3">
          รายละเอียด
        </div>

        <TinyMCE
          readOnly={false}
          value={detailValue}
          setValue={setDetailValue}
        />

        <div className="flex flex-row sm:flex-col justify-between gap-5 sm:gap-0">
          <div className="mt-4 w-full">
            <Datepicker
              label="วันที่เผยแพร่"
              value={publishStartDate}
              setValue={setPublishStartDate}
              className="md:text-[14px] text-xl text-[#000000] md:my-1 my-3"
              title="publicity"
            ></Datepicker>
          </div>
          <div className="mt-4 w-full">
            <Datepicker
              label="วันที่สิ้นสุดเผยแพร่"
              value={publishEndDate}
              setValue={setPublishEndDate}
              className="md:text-[14px] text-xl text-[#000000] md:my-1 my-3"
              title="publicity"
            ></Datepicker>
          </div>
        </div>
        <div className="mt-4 flex flex-col sm:flex-row sm:gap-5 sm:justify-around">
          <div className="w-full sm:w-auto">
            <ToggleCheckbox
              label="เปิดการใช้งาน"
              value={active}
              setValue={setActive}
              // className="md:text-[14px] text-xl text-[#000000] md:my-1 my-3"
            ></ToggleCheckbox>
          </div>
          <div className="w-full sm:w-auto hidden sm:block">
            <ToggleCheckbox
              label="ปักหมุด"
              value={pined}
              setValue={setPined}
              className="md:text-[14px] text-xl text-[#000000] md:my-1 my-3"
            ></ToggleCheckbox>
          </div>
        </div>
      </div>

      <div className="flex justify-center md:my-2 my-6">
        {location.state?.data !== undefined ? (
          <>
            <button
              onClick={() => {
                onClickUpdateSubmit("news");
              }}
              className="button-theme-pg flex justify-center items-center md:w-24 md:h-8 w-48 h-10 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 text-[#000000] shadow-sm shadow-brand-cyan "
            >
              แก้ไข
            </button>
          </>
        ) : (
          <button
            onClick={() => {
              onClickAddSubmit(location.state?.type);
            }}
            className="button-theme-pg flex justify-center items-center w-48 h-10 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 text-[#000000] shadow-sm shadow-brand-cyan "
          >
            บันทึก
          </button>
        )}
      </div>
    </div>
  );
}

export default AddDataUseQuillEditor;
